// extracted by mini-css-extract-plugin
export default {"loader":"LoadingSpinner_loader__Z8ONC","dual-ring":"LoadingSpinner_dual-ring__uhy5H"};